require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-nhs-diagnosis.json") })
        }
      }, "path---article-nhs-diagnosis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-nhs-diagnosis!./.cache/json/article-nhs-diagnosis.json
// module id = 363
// module chunks = 231608221292675